<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>CALL&nbsp;&nbsp;FOR&nbsp;&nbsp;SPONSORS</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
         <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">铂金合作单位</span>
          </div>
          <div class="item-content">
            <div class="item-text-content">
              <div class="zanshushang-list">
                <a :href="item.href" target="_blank" class="sponsors-item" v-for="item in sponsors.bojin">
                  <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">

                  </div>
                  <div class="sponsor-name">{{item.nameabb}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">金牌合作单位</span>
          </div>
          <div class="item-content">
            <div class="item-text-content">
              <div class="zanshushang-list">
                <a :href="item.href" target="_blank" class="sponsors-item" v-for="item in sponsors.jinpai">
                  <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">
                  </div>
                  <div class="sponsor-name">{{item.nameabb}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">银牌合作单位</span>
          </div>
          <div class="item-content">
            <div class="item-text-content">
              <div class="zanshushang-list">
                <a :href="item.href" target="_blank" class="sponsors-item" v-for="item in sponsors.yinpai">
                  <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">
                  </div>
                  <div class="sponsor-name">{{item.nameabb}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2026 诚招合作</span>
          </div>
          <div class="item-content" v-show="true">
            <!--<p class="content-null-info">敬请期待......</p>-->
            <div class="item-text-content">
              <!--<div class="font-weight text-indent-null text-main-color item-text-content-title">-->
                <!--VALSE 2019 诚招合作-->
              <!--</div>-->
              <p>
                视觉与学习青年学者研讨会 (以下简称VALSE)是一个面向计算机视觉与机器学习领域国内外华人青年学者的学术研讨会。2011年举办第一届研讨会以来，迄今已举办15届，2019年VALSE大会参会人数已达5017人。15年来，VALSE逐渐形成了自己的特色社区文化、找准了自己的使命。2014年以来，VALSE定期举办VALSE Webinar学术报告会，每次的在线参加人数在200-1500人不等。VALSE现已有品牌活动《VALSE Webinar》、《VALSE短教程》、《VALSE论文速览》。VALSE Online 迄今已组织405期在线学术报告，B站所存放VALSE Webinar视频截至目前累计播放量181.9万，单个视频的最高播放量在5.6万次。逐渐形成了一个独具特色、高效实用的在线学术交流平台。    

              </p><p>
                VALSE 2026将在武汉举办，由华中科技大学、武汉大学、中国地质大学（武汉）承办，预计参会人数5000人。为了办好VALSE 2026盛会，我们诚挚邀请相关企业合作！
              </p>
              <div class="font-weight text-indent-null text-main-color item-text-content-title">
                企业合作联系人
              </div>
              <ul>
                <li style="list-style: none;text-indent: 0em;">
                  白翔 (xbai@hust.edu.cn)
                </li>
                <li style="list-style: none;text-indent: 0em;">
                  山世光 (sgshan@ict.ac.cn)
                </li>
                <li style="list-style: none;text-indent: 0em;">
                  程明明 (cmm@nankai.edu.cn)
                </li>
                <li style="list-style: none; text-indent: 0em;">
                  姬艳丽 (yanliji@uestc.edu.cn)
                </li>
              </ul>
              <div class="font-weight text-indent-null text-main-color item-text-content-title">
                企业合作分级分类
              </div>
              <p>VALSE 2026 设三个级别的合作单位，分别为：</p>
              <p><b>铂金：20 万元（最多5个）</b></p>
              <p><b>金牌：10 万元</b></p>
              <p><b>银牌：5 万元</b></p>
              <p>不同级别的合作单位可享受不同的企业权益 (以下各项如涉及合作单位顺序，均以铂金、金牌、银牌合作单位顺序排序，同一级别的排序将综合考虑合作确定时间和历史合作总额)。各级别合作单位的通用合作权益包括：</p>
              <p>1. 研讨会程序册显著位置上印刷合作单位Logo并致谢，会议网站上链接合作公司网站主页；</p>
              <p>2. 在研讨会开幕式或闭幕式上，接受大会颁发的感谢牌；</p>
              <p>3. 合作单位可自行携带一张易拉宝，放于会场外用于公司宣传或发布招聘信息等；</p>
              <p>4. 在会议资料包中发放企业介绍资料或小礼品；</p>
              <p>5. 会议网站链接公司招聘宣传，合作单位晚宴报名链接。</p>
              <p>为了提高宣讲时上座率，<span class="text-red">企业宣讲前后都安排有重磅学术报告。</span></p>
              
              <div class="font-weight text-indent-null text-main-color item-text-content-title">不同合作单位的差异化权益如下：</div>
              <p><b>铂金合作单位权益：</b></p>
              <p>1. 在VALSE<span class="text-red">大会上做8分钟企业技术宣讲</span>；</p>
              <p>2. 企业介绍<span class="text-red">视频：时长8分钟</span>，会场合适位置大电视循环播放；</p>
              <p>3. 参会 VIP 名额：<span class="text-red">6人</span>（无注册费，可享受 VIP 餐饮和 VIP 座位安排）；</p>
              <p>4. 企业展台：提供<span class="text-red">25平方米展览空间</span>，供合作单位展示，特殊搭建费用自理；</p>
              <p>5. VALSE与铂金合作单位合作打造<span class="text-red">VALSE webinar企业专场</span>。</p>
              <p><b>金牌合作单位权益：</b></p>
              <p>1. 在VALSE<span class="text-red">分会场上8分钟企业技术宣讲</span>；</p>
              <p>2. 企业介绍<span class="text-red">视频：时长5分钟</span>，会场合适位置大电视循环播放；</p>
              <p>3. 参会 VIP 名额：<span class="text-red">3人</span>（无注册费，可享受 VIP 餐饮和 VIP 座位安排）；</p>
              <p>4. 企业展台：提供<span class="text-red">16平方米展览空间</span>，供合作单位展示，特殊搭建费用自理。</p>
              <p><b>银牌合作单位权益：</b></p>
              <p>1. 企业介绍<span class="text-red">视频：时长3分钟</span>，会场合适位置大电视循环播放；</p>
              <p>2. 参会 VIP 名额：<span class="text-red">2人</span>（无注册费，可享受 VIP 餐饮和 VIP 座位安排）；</p>
              <p>3. 企业展台：提供<span class="text-red">9平方米展览空间</span>，供合作单位展示，特殊搭建费用自理；</p>
              <p>
                <div class="font-weight text-indent-null text-main-color item-text-content-title">>>>其他事项<<<</div>
              </p>
              <p>1. 合作单位参会人员（包括 VIP）参会费用自理。</p>
              <p>2. VALSE 大会对所有参会人员免收注册费， 故合作单位如有意安排本企业员工参加大会，请直接按会议网站要求注册即可参会。</p>
              <p>3. 鉴于历年VALSE报名过于火爆，为保证合作单位有足够参会名额，2026年大会组委会为每家合作单位预留一定<b>普通参会名额（非VIP）</b>：铂金12人，金牌8人，银牌 5人。</p>
            
            </div>
          </div>
        </div>
        
       
        <div class="content-item" v-show="false">
          <div class="item-title">
            <span class="item-title-content">合作单位组织活动信息
            <br>
            <span class="item-title-label" style="color:red;">点击海报即可报名</span>
            </span>
          </div>
          <div class="item-content">
            <div class="item-text-content">
              <div class="zanshushang-list">
                <a :href="item.actref" target="_blank"  class="sponsors-item sponsor-activity-content" v-for="item in sponsors.bojin" v-if="item.hasOwnProperty('time') && item.time!=''">
                  <!-- <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">

                  </div> -->
                  <div class="sponsor-name">{{item.acttitle}}</div>
                  
                  <div class="sponsor-activity">
                    <!-- <div class="sponsor-activity-tile">时间：<span class='activity-content'>{{item.time}}</span></div>
                    <div class="sponsor-activity-tile">地点：{{item.addr}}</div>
                    <div class="sponsor-activity-tile" >报名：<span class='activity-content'>{{item.actbaoming}}</span></div> -->
                    <!-- <div class="sponsor-activity-tile" style="color:#F56C6C; text-align:right;"><a :href="item.actref" target="_blank" >点击报名</a></div> -->
                    <!-- <div class="sponsor-activity-tile">简介：{{item.content}}</div> -->
                    <img :src="item.actimage">
                  </div>
                  
                </a>
                <a :href="item.actref" target="_blank"  class="sponsors-item sponsor-activity-content" v-for="item in sponsors.jinpai" v-if="item.hasOwnProperty('time') && item.actimage!=''">
                  <!-- <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">

                  </div> -->
                  <div class="sponsor-name">{{item.acttitle}}</div>
                  
                  <div class="sponsor-activity">
                    <!-- <div class="sponsor-activity-tile">时间：<span class='activity-content'>{{item.time}}</span></div>
                    <div class="sponsor-activity-tile">地点：{{item.addr}}</div>
                    <div class="sponsor-activity-tile" >报名：<span class='activity-content'>{{item.actbaoming}}</span></div> -->
                    <!-- <div class="sponsor-activity-tile" style="color:#F56C6C; text-align:right;"><a :href="item.actref" target="_blank" >点击报名</a></div> -->
                    <!-- <div class="sponsor-activity-tile">简介：{{item.content}}</div> -->
                    <img :src="item.actimage">
                  </div>
                  
                </a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Sponsors",
      data(){
          return {
            sponsors:this.$dicts.sponsors,
            sponsorsBojin:this.$dicts.sponsors.bojin,
            sponsorsJinpai:this.$dicts.sponsors.jinpai,
            sponsorsYinpai:this.$dicts.sponsors.yinpai,
          }
      }
    }
</script>

<style scoped>
.footer{
    /* position: fixed; */
    bottom: 0;
  }
  .program_banner{
    background-image: url("../../static/images/sub_banner/04.jpg");
  }
  .program_banner p{
    /*color: white;*/
  }
  .item-text-content-title{
    padding-top: 26px;
    line-height: 1em;
  }

  .zanshushang-list{
    display: flex;
    flex-wrap:wrap;
    justify-content:space-between;
  }
  .zanshushang-list .sponsors-item{
    padding: 4px 8px;
    margin: 2px;
    margin-bottom: 8px;
    background-color: #f3f3f3;
    color: #0053a1;
    border: 1px solid #DCDFE6;
    border-radius: 5px;

  }
  .zanshushang-list .sponsors-item:hover{
    cursor: pointer;
    background-color: #DCDFE6;
    color: #f27d00;
  }

  .zanshushang-list .sponsors-item .sponsor-logo{
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    height: 90px;
    width: 200px;

  }
  .zanshushang-list .sponsors-item .sponsor-name{
    text-align: center;
    text-indent: 0;
    font-weight: 700;
  }
  .sponsor-activity-content{
    width: 328px;
    height: 430px;
    overflow-y: auto;
  }
  .sponsor-activity img{
    /* height: 400px; */
    width: 320px;
  }
  .sponsor-activity{
    text-align: left;
    text-indent:0;
    font-size: 14px;
    line-height:1.5em;
    color: #606266;
  }
  .activity-content{
    color: #F56C6C;
  }
  .item-title-label{
    font-size: 12px;
    color: #2c3e50;
    padding-top: -10px;
  }
  @media screen  and (max-width: 800px){
    .program_banner{
      /*background-image: url("../../static/images/sponsors_mobile_banner.jpg");*/
      background-size: cover;
      background-position: 40% 100%;
    }
    .zanshushang-list{
      justify-content:center;
    }

  }
  @media screen and (max-width: 400px){
    .program_banner p{
      font-size: 24px;
    }
    .zanshushang-list{
      justify-content:center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Sponsors.vue